export const currencyTranslations = {
  fa: {
    usd: 'دلار آمریکا',
    eur: 'یورو',
    gbp: 'پوند انگلیس',
    chf: 'فرانک سوئیس',
    cad: 'دلار کانادا',
    aud: 'دلار استرالیا',
    sek: 'کرون سوئد',
    nok: 'کرون نروژ',
    rub: 'روبل روسیه',
    thb: 'بات تایلند',
    sgd: 'دلار سنگاپور',
    hkd: 'دلار هنگ کنگ',
    azn: 'منات آذربایجان',
    amd: '۱۰ درام ارمنستان',
    dkk: 'کرون دانمارک',
    aed: 'درهم امارات',
    jpy: '۱۰ ین ژاپن',
    try: 'لیر ترکیه',
    cny: 'یوآن چین',
    sar: 'ریال عربستان',
    inr: 'روپیه هند',
    myr: 'رینگیت مالزی',
    afn: 'افغانی افغانستان',
    kwd: 'دینار کویت',
    iqd: '۱۰۰ دینار عراق',
    bhd: 'دینار بحرین',
    omr: 'ریال عمان',
    qar: 'ریال قطر',
    nzd: 'دلار نیوزیلند',
    krw: 'وون کره جنوبی',
    irr: 'ریال ایران',
    toman: 'تومان',

    // Gold & Metals
    abshodeh: 'مثقال طلا (آبشده)',
    '18ayar': 'طلای ۱۸ عیار',
    ounce: 'انس طلا',
    sekkeh: 'سکه امامی',
    bahar: 'سکه بهار آزادی',
    nim: 'نیم سکه',
    rob: 'ربع سکه',
    gerami: 'سکه گرمی',
  },
  en: {
    usd: 'US Dollar',
    eur: 'Euro',
    gbp: 'British Pound',
    chf: 'Swiss Franc',
    cad: 'Canadian Dollar',
    aud: 'Australian Dollar',
    sek: 'Swedish Krona',
    nok: 'Norwegian Krone',
    rub: 'Russian Ruble',
    thb: 'Thai Baht',
    sgd: 'Singapore Dollar',
    hkd: 'Hong Kong Dollar',
    azn: 'Azerbaijani Manat',
    amd: '10 Armenian Dram',
    dkk: 'Danish Krone',
    aed: 'UAE Dirham',
    jpy: '10 Japanese Yen',
    try: 'Turkish Lira',
    cny: 'Chinese Yuan',
    sar: 'Saudi Riyal',
    inr: 'Indian Rupee',
    myr: 'Malaysian Ringgit',
    afn: 'Afghan Afghani',
    kwd: 'Kuwaiti Dinar',
    iqd: '100 Iraqi Dinar',
    bhd: 'Bahraini Dinar',
    omr: 'Omani Rial',
    qar: 'Qatari Rial',
    nzd: 'New Zealand Dollar',
    krw: 'South Korean Won',
    irr: 'Iranian Rial',
    toman: 'Toman',

    // Gold & Metals
    abshodeh: 'Mithqal (Melted Gold)',
    '18ayar': '18 Karat Gold',
    ounce: 'Gold Ounce',
    sekkeh: 'Emami Gold Coin',
    bahar: 'Bahar Azadi Coin',
    nim: 'Half Azadi Coin',
    rob: 'Quarter Azadi Coin',
    gerami: 'Gerami Coin',
  },
};

export const translations = {
  en: {
    appTitle: 'ArzGoo',
    installApp: 'Install App',
    installTooltip: 'Install App to Home Screen',
    themeLight: 'Switch to Light Theme',
    themeDark: 'Switch to Dark Theme',
    langToggle: 'فارسی',
    langTooltip: 'Switch to Persian',

    // PWA Install Dialog
    installInstructionsTitle: 'Install ArzGoo App',
    installInstructionsDesc: 'To install ArzGoo on your Home Screen:',
    mobileTitle: '📱 Mobile (Chrome / Safari / Edge):',
    mobileStep1: 'Tap the browser Menu (or Share button on iOS)',
    mobileStep2: 'Select "Add to Home Screen" or "Install App".',
    desktopTitle: '💻 Desktop (Chrome / Edge):',
    desktopStep1: 'Click the Install Icon in your browser address bar.',
    ok: 'OK',

    // Market Overview
    liveMarketRates: 'Live Market Rates',
    liveMarketDesc: 'Real-time foreign exchange and precious metals rates updated directly from live financial sources.',
    live: 'Live',
    updating: 'Updating...',
    totalAssets: 'Total Assets',
    quotes: 'Quotes',
    lastUpdated: 'Last Updated',
    loading: 'Loading...',

    // Controls Bar
    allMarkets: 'All Markets',
    currencies: 'Currencies',
    goldMetals: 'Gold & Metals',
    searchPlaceholder: 'Search currency or gold...',
    converter: 'Converter',
    refreshRates: 'Refresh Rates',

    // Currency Card
    sellRate: 'Sell Rate',
    buyRate: 'Buy Rate',
    fxTag: 'FX',
    goldTag: 'Gold',

    // Converter Modal
    currencyConverter: 'Currency Converter',
    amountToConvert: 'Amount to Convert',
    fromCurrency: 'From Currency',
    toCurrency: 'To Currency',
    swapCurrencies: 'Swap Currencies',
    tomanName: 'Iranian Toman',
    toman: 'Toman',

    // Empty State
    noQuotesFound: 'No Quotes Found',
    noQuotesDesc: 'We couldn\'t find any currency or gold item matching "{query}".',
    clearFilters: 'Clear Filters',
  },
  fa: {
    appTitle: 'ارزگو',
    installApp: 'نصب برنامه',
    installTooltip: 'نصب برنامه روی صفحه اصلی',
    themeLight: 'تغییر به پوسته روشن',
    themeDark: 'تغییر به پوسته تاریک',
    langToggle: 'English',
    langTooltip: 'تغییر به زبان انگلیسی',

    // PWA Install Dialog
    installInstructionsTitle: 'نصب برنامه ارزگو',
    installInstructionsDesc: 'برای نصب ارزگو روی صفحه اصلی گوشی یا کامپیوتر:',
    mobileTitle: '📱 موبایل (کروم / سافاری / اج):',
    mobileStep1: 'منوی مرورگر (یا دکمه Share در آیفون) را لمس کنید',
    mobileStep2: 'گزینه «افزودن به صفحه اصلی» یا «Install App» را انتخاب کنید.',
    desktopTitle: '💻 کامپیوتر (کروم / اج):',
    desktopStep1: 'روی آیکون نصب در نوار آدرس مرورگر کلیک کنید.',
    ok: 'متوجه شدم',

    // Market Overview
    liveMarketRates: 'نرخ‌های لحظه‌ای بازار',
    liveMarketDesc: 'نرخ لحظه‌ای ارزهای خارجی و فلزات گرانبها مستقیم از منابع معتبر مالی.',
    live: 'زنده',
    updating: 'در حال به روزرسانی...',
    totalAssets: 'کل دارایی‌ها',
    quotes: 'مظنه',
    lastUpdated: 'آخرین به روزرسانی',
    loading: 'در حال بارگذاری...',

    // Controls Bar
    allMarkets: 'همه بازارها',
    currencies: 'ارزها',
    goldMetals: 'طلا و سکه',
    searchPlaceholder: 'جستجوی ارز یا طلا...',
    converter: 'مبدل ارز',
    refreshRates: 'به روزرسانی نرخ‌ها',

    // Currency Card
    sellRate: 'نرخ فروش',
    buyRate: 'نرخ خرید',
    fxTag: 'ارز',
    goldTag: 'طلا',

    // Converter Modal
    currencyConverter: 'مبدل ارز',
    amountToConvert: 'مبلغ جهت تبدیل',
    fromCurrency: 'ارز مبدا',
    toCurrency: 'ارز مقصد',
    swapCurrencies: 'جابجایی ارزها',
    tomanName: 'تومان ایران',
    toman: 'تومان',

    // Empty State
    noQuotesFound: 'موردی یافت نشد',
    noQuotesDesc: 'هیچ ارز یا طلایی با عبارت «{query}» یافت نشد.',
    clearFilters: 'پاک کردن فیلترها',
  },
};

export const toPersianDigits = (str) => {
  if (str === null || str === undefined) return '';
  const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  return String(str).replace(/[0-9]/g, (w) => farsiDigits[parseInt(w, 10)]);
};

export const parsePersianNumber = (str) => {
  if (str === null || str === undefined) return 0;
  const englishStr = String(str)
    .replace(/[۰٠]/g, '0')
    .replace(/[۱١]/g, '1')
    .replace(/[۲٢]/g, '2')
    .replace(/[۳٣]/g, '3')
    .replace(/[۴٤]/g, '4')
    .replace(/[۵٥]/g, '5')
    .replace(/[۶٦]/g, '6')
    .replace(/[۷٧]/g, '7')
    .replace(/[۸٨]/g, '8')
    .replace(/[۹٩]/g, '9')
    .replace(/,/g, '')
    .replace(/٫/g, '.');
  const val = parseFloat(englishStr);
  return isNaN(val) ? 0 : val;
};

export const formatDigits = (str, lang) => {
  if (str === null || str === undefined) return '';
  return lang === 'fa' ? toPersianDigits(str) : String(str);
};

export const getTranslation = (lang, key, params = {}) => {
  const currentLang = translations[lang] ? lang : 'fa';
  let text = translations[currentLang][key] || translations['en'][key] || key;

  Object.keys(params).forEach((pKey) => {
    const val = currentLang === 'fa' ? toPersianDigits(params[pKey]) : params[pKey];
    text = text.replace(`{${pKey}}`, val);
  });

  return text;
};

export const getCurrencyFullName = (lang, shortCode, defaultName = '') => {
  if (!shortCode) return defaultName;
  const code = String(shortCode).toLowerCase().trim();
  const currentLang = lang === 'fa' ? 'fa' : 'en';
  
  if (currencyTranslations[currentLang] && currencyTranslations[currentLang][code]) {
    return currencyTranslations[currentLang][code];
  }
  
  return defaultName || shortCode;
};
